export default class HandleAddToCart {
    init() {
        this.afterAddToCart();
    }

    afterAddToCart() {
        $('body').on('product:afterAddToCart', (e, response) => {
            const $ctaContainer = $('.cart-and-ipay:has(.pdp-checkout-button)');
            $ctaContainer.toggleClass('already-in-cart', !response.error);
        });
    }
}
